__turbopack_context__.v({
  "description": "SAQImageColTextForm-module-scss-module__DzcNmq__description",
  "formHeading": "SAQImageColTextForm-module-scss-module__DzcNmq__formHeading",
  "formTagline": "SAQImageColTextForm-module-scss-module__DzcNmq__formTagline",
  "imageColTextForm": "SAQImageColTextForm-module-scss-module__DzcNmq__imageColTextForm",
  "imageColTextForm--imageSmallDesign": "SAQImageColTextForm-module-scss-module__DzcNmq__imageColTextForm--imageSmallDesign",
  "imageColTextFormSection": "SAQImageColTextForm-module-scss-module__DzcNmq__imageColTextFormSection",
  "imageSection": "SAQImageColTextForm-module-scss-module__DzcNmq__imageSection",
  "textSection": "SAQImageColTextForm-module-scss-module__DzcNmq__textSection",
});
